import { useCanvasStore } from './canvas-store';
import { attachReferenceToExistingTask } from './reference-destination';

/** Attach an Inspiration still to an authorized task's composer, without starting a chat turn. */
export function attachInspirationReference(projectId: number, imageUrl: string, imageName: string): Promise<string> {
  return attachReferenceToExistingTask({
    getState: () => useCanvasStore.getState(),
    restoreActive: (previous) => useCanvasStore.setState(previous),
    request: (input, init) => fetch(input, init),
  }, projectId, imageUrl, imageName);
}
